import { render, staticRenderFns } from "./MatrixSalesReport.vue?vue&type=template&id=2f96c706&"
import script from "./MatrixSalesReport.vue?vue&type=script&lang=js&"
export * from "./MatrixSalesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports